import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import { GRANULARITY } from '../../../CustomReport/consts';

const mapGranularityToString = {
  [GRANULARITY.MONTHS]: 'Monthly',
  [GRANULARITY.WEEKS]: 'Weekly',
  [GRANULARITY.DAYS]: 'Daily'
};

const Granularity = () => {
  const {
    state: { granularity }
  } = useContext(MetricsInspectionContext);

  const granularityStr = mapGranularityToString[granularity];

  return <div>{granularityStr}</div>;
};

export default Granularity;
